import React from "react";

const Footer = () => {
  return (
    <div className="footer-copyright text-center p-2 mt-auto">
      Pizza order Composer &copy; Paragon
    </div>
  );
};

export default Footer;
